
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table } from "antd";

const PaginationDataTable = ({
  columns,
  dataSource = [],
  bordered = false,
  stickyHeader = false,
  showSlno = true,
  currentPage = 1,
  pageSize = 30,
  totalRecords = 0,
  onPageChange,
}) => {
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  const handleSearch = (value) => {
    if (!value) {
      setFilteredDataSource(dataSource);
      return;
    }
    const filtered = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredDataSource(filtered);
  };

  const modifiedColumns = showSlno
    ? [
        {
          title: "Sl. No",
          key: "slno",
          width: 80,
          render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
        },
        ...columns,
      ]
    : columns;

  return (
    <>
      <div className="search-set table-search-set no-search">
        <div className="search-input d-none">
          <a href="#" className="btn btn-searchset">
            <i className="ti ti-search fs-14 feather-search" />
          </a>
          <div className="dataTables_filter ">
            <label>
              <input
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Search"
              />
            </label>
          </div>
        </div>
      </div>

      <Table
        className="table datanew dataTable no-footer"
        columns={modifiedColumns}
        dataSource={filteredDataSource}
        rowKey={(record) => record.Id || record.id}
        bordered={bordered}
        scroll={{ x: "max-content", ...(stickyHeader && { y: 500 }) }}
        pagination={{
          current: currentPage,
          pageSize,
          total: totalRecords,
          showSizeChanger: true,
          pageSizeOptions: ["30", "50", "100", "150"],
          onChange: onPageChange,
        }}
      />
    </>
  );
};

PaginationDataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array,
  bordered: PropTypes.bool,
  stickyHeader: PropTypes.bool,
  showSlno: PropTypes.bool,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  totalRecords: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};

export default PaginationDataTable;
